import React from 'react';

const TeleprompterView = <span>Switch to Prompter View</span>;

const EnterFullscreen = <span>Switch to full screen</span>;

const ExitFullscreen = <span>Exit full screen</span>;

const PastListTrash = (
  <div>
    <span>Move this event to the trash.</span>
    <br />
    <span>You can always restore it later.</span>
  </div>
);

const UserDashViewPastEventsBtn = (
  <div>
    <span>
      View all events more <br />
      than seven days old
    </span>
  </div>
);

const UserDashCreateEventBtn = (
  <div>
    <span>
      Create events and <br />
      invite your crew.
    </span>
  </div>
);

const UserDashRecentEvents = (
  <div>
    <span>
      Past events are read only. After 2 weeks, events are accessible by Team
      Admins via the Team's past events page.
    </span>
  </div>
);

const UpcomingListEdit = (
  <div>
    <span>Edit event settings including name, date & location.</span>
  </div>
);

const UpcomingListDuplicate = (
  <div>
    <span>Duplicate this event including shows, crew & settings.</span>
  </div>
);

const UpcomingListTrash = (
  <div>
    <span>Move this event to the trash. You can always restore it later.</span>
  </div>
);

const ArchiveEventListRestore = (
  <div>
    <span>
      This will restore your event to either past or upcoming events based on
      event date range.
    </span>
  </div>
);

const PastListDuplicate = (
  <div>
    <span>
      This will duplicate this event including shows & crew. Once duplicated you
      can change the event's name & date range.
    </span>
  </div>
);

const TeamMembersRemoveCrewBtn = (
  <div>
    <span>
      Removes user from the team. They will no longer see & manage your team's
      events.
    </span>
  </div>
);

const EventShowsListItemGuestPass = (
  <div>
    <span>Toggle guest pass access</span>
  </div>
);

const EventShowsListItemMove = (displayType) => {
  return (
    <div>
      <span>Move this {displayType} to another folder.</span>
    </div>
  );
};

const EventShowsListItemEdit = (displayType) => {
  return (
    <div>
      <span>
        Edit {displayType} settings including name, date, location, start time,
        and show specific settings.
      </span>
    </div>
  );
};

const EventShowsListItemDuplicate = (displayType) => {
  return (
    <div>
      <span>Duplicate this {displayType}.</span>
    </div>
  );
};

const EventShowsListItemSave = (displayType) => {
  return (
    <div>
      <span>
        Saves a version of this {displayType} below. Great for backups! You can
        always restore later.
      </span>
    </div>
  );
};

const EventShowsListItemTrash = (displayType) => {
  return (
    <div>
      <span>
        Move this {displayType} to the trash. You can always restore it later.
      </span>
    </div>
  );
};

const EventShowsListItemConvertShow = (
  <div>
    <span>Convert this show to a schedule or list.</span>
  </div>
);

const EventShowsListItemConvertList = (
  <div>
    <span>Convert this list to a show or schedule.</span>
  </div>
);

const EventShowsListItemConvertSchedule = (
  <div>
    <span>Convert this schedule to a show or list.</span>
  </div>
);

const EventShowsListItemShowItemDesc = (
  <div>
    <span>
      Turn item descriptions on / off for the entire show & for all users.
    </span>
  </div>
);

const EventShowsListItemShowClocks = (
  <div>
    <span>
      Show or hide the item run time & timeof day clocks for this show.
    </span>
  </div>
);

const EventShowsListItemShowStartTime = (
  <div>
    <span>Show or hide item start times for all items in the show.</span>
  </div>
);

const EventShowsListItemAutoTimeCalcs = (
  <div>
    <span>
      Turn auto start & preset time calculations on / off.
      <br /> Off will turn all start & preset times into manual.
    </span>
  </div>
);
const EventShowsListItemAutoItemNumsCalcs = (
  <div>
    <span>
      Turn auto item numbers on and Shoflo will automatically count up all item
      numbers. When off, item #s will be manual.
    </span>
  </div>
);

const EventShowsListItemPresetTime = (
  <div>
    <span>
      Show or hide item preset times for all items in the show. Preset times
      count down and display how much time is left in a show.
    </span>
  </div>
);

const EventShowsHeaderImportCSVBtn = (
  <div>
    <span>
      Import your existing Excel sheets or shows into Shoflo by importing them
      as CSVs.
    </span>
  </div>
);

const EventCrewRoleSelector = (
  <div>
    <span>
      Read Only – Can personalize with notes, highlights and column ordering.
      <br />
      <br />
      Contributor – Same as Read Only, but can edit cells within department
      columns.
      <br />
      <br />
      Admin – Manage event & crew. Can edit everything.
      <br />
      <br />
      Show Caller – Same as Admin & can be tracked by other users.
    </span>
  </div>
);

const EventRemoveCrewBtn = (
  <div>
    <span>Removes user from this list.</span>
  </div>
);

const EventUpcomingListLocation = (
  <div>
    <span>
      Identify the location of your event. City, state, venue... wherever.
    </span>
  </div>
);

const EventDocsListItemRestore = (
  <div>
    <span>Restore this document.</span>
  </div>
);

/*
 * Cuesheet Tooltips
 */

const CSDurationSuppression =
  'Mutes or unmutes the duration.  ' +
  'When muted, it won’t impact the start or preset time of the next item.';

const CSRunTimeSuppression =
  'Enables or disables the item run clock.  ' +
  'When disabled, the clock will continue counting from the previously tracked item.';

const CSHamburger = (
  <div>
    <span>
      Click this icon to bring up your side nav to easily navigate throughout
      Shoflo.
    </span>
  </div>
);

const CSShowSelector = (
  <div>
    <span>Quickly switch between shows in your event.</span>
  </div>
);

const CSItemRunTime = (
  <div>
    <span>How long the Show Caller has been in the current item.</span>
  </div>
);

const CSTimeOfDay = (
  <div>
    <span>Time of Day. Adjustable from the event settings.</span>
  </div>
);

const CSThemeSwitcher = (
  <div>
    <span>Switch between light & dark theme.</span>
  </div>
);

const CSInfo = (
  <div>
    <span>This will take you to our learn section.</span>
  </div>
);

const CSActivityFeed = (
  <div>
    <span>Activity Feed</span>
  </div>
);

const CSActivityFeedUndoIcon = (
  <div>
    <span>Restore Content</span>
  </div>
);

const CSActivityFeedListIcon = (
  <div>
    <span>Content History</span>
  </div>
);

const CSDownloads = (
  <div>
    <span>
      Click here to export this show to Excel, CSV, Generic PDF, Personal PDF,
      and get the link for guest pass.
    </span>
  </div>
);

const CSXLSExport = (
  <div>
    <span>Exports all columns with basic formatting.</span>
  </div>
);

const CSPersonalXLSExport = (
  <div>
    <span>Pre-formatted XLS based on your visible column order.</span>
  </div>
);

const CSCSVExport = (
  <div>
    <span>Exports all columns with no formatting.</span>
  </div>
);

const CSPersonalCSVExport = (
  <div>
    <span>Pre-formatted CSV based on your visible column order.</span>
  </div>
);

const CSPersonalPDFExport = (
  <div>
    <span>Pre-formatted PDF based on your visible column order.</span>
  </div>
);

const CSGenericPDFExport = (
  <div>
    <span>Pre-formatted PDF showing all columns including hidden.</span>
  </div>
);

const CSGuestPass = (
  <div>
    <span>Pre-formatted Public Link showing all columns including hidden.</span>
  </div>
);

const EventGuestPass = (
  <div>
    <span>
      Guest pass landing page with links to all shows that currently have guest
      pass enabled
    </span>
  </div>
);

// eslint-disable-next-line no-unused-vars
const CSRowMenu = (
  <div>
    <span>
      Edit settings for this row such as global and personal highlights, copy
      and paste, duplication, tracking, add/delete rows, and convert rows to
      title rows or item rows.
    </span>
  </div>
);

const CSHeaderCell = (
  <div>
    <span>You can hide & re-order columns based on your role.</span>
  </div>
);

const GEMHeaderCell = (
  <div>
    <span>You can change column widths & add/remove columns.</span>
  </div>
);

const CSNoteHeaderCell = (
  <div>
    <span>Add your own notes in this column. No one else will see them.</span>
  </div>
);

const CSProofHeaderCell = (
  <div>
    <span>
      Place timestamps for a Proof of Performance that can be exported to XLS.
    </span>
  </div>
);

const CSTrackingName = (
  <div>
    <span>
      Select the show caller you would like to track during this show. If no
      names appear, make sure you set someone's permission to be show caller
      from the crew page.
    </span>
  </div>
);

const CSGlobalHighlight = (
  <div>
    <span>Global Highlight - Seen by everyone, a full row highlight.</span>
  </div>
);

const CSPersonalHighlight = (
  <div>
    <span>Personal Highlight - Seen by only you, an accent row highlight.</span>
  </div>
);

const CSTrackItem = (
  <div>
    <span>
      Sets your current tracking position. Will jump users currently tracking to
      this item.
    </span>
  </div>
);

const CSToolbarImage = (
  <div>
    <span>Add an image to the selected cell.</span>
  </div>
);

const CSToolbarLink = (
  <div>
    <span>Insert a web link into a cell.</span>
  </div>
);

const CSToolbarTimeStamp = (
  <div>
    <span>
      Insert a time stamp into the selected cell. Great for proof of
      performance.
    </span>
  </div>
);

const CSSavedVsDuplicate = (
  <div>
    <span>Duplicates a copy of this show into active shows above.</span>
  </div>
);

const CSSavedVsTitle = (
  <div>
    <span>
      Saved copy of your show. Click to review, even copy & paste items.
    </span>
  </div>
);

const CSRestoreShow = (
  <div>
    <span>Restores this show to either saved or active shows.</span>
  </div>
);

const CSReturnToTrackingLink = (
  <div>
    <span>Return to tracking</span>
  </div>
);

const CSStopBroadcastingTrackingLink = (
  <div>
    <span>Stop broadcasting your tracking position</span>
  </div>
);

const ResendEmailPendingUser = (
  <div>
    <span>Resend an email to pending user</span>
  </div>
);

//Only using CMD because its only displayed on Safari
const ManualCopyLink = (
  <div>
    <span>Use CMD + C to copy</span>
  </div>
);

import UserRolesConstants from 'shared/constants/UserRoles';

const SignupRole1 = (
  <div>
    <span>{UserRolesConstants.role1}</span>
  </div>
);

const SignupRole2 = (
  <div>
    <span>{UserRolesConstants.role2}</span>
  </div>
);

const SignupRole3 = (
  <div>
    <span>{UserRolesConstants.role3}</span>
  </div>
);

const SignupRole4 = (
  <div>
    <span>{UserRolesConstants.role4}</span>
  </div>
);

const PresetDisplayTypePreset = (
  <div>
    <span>Format as MMmSSs (ex: 90m30s)</span>
  </div>
);

const PresetDisplayTypeClock = (
  <div>
    <span>Format similar to a game clock (MM:SS) (90:30)</span>
  </div>
);

const PresetDisplayTypeSixDigit = (
  <div>
    <span>Format as six digits (HH:MM:SS) (01:30:30)</span>
  </div>
);

const WordExportHeroColumnExplanation =
  'Hero columns will receive a larger font size on export--great for scripts and PA reads!';

const WordExportShare =
  'Export your shows to Word with special formatting options for scripts';

const CSSearch = 'Find & Replace content in your show';

const StartTimeEyeball = "Hide the start time so it won't display on this item";
const StartTimeReverseFlag = 'Have start times calculate in reverse';
const StartTimeForwardFlag = 'Have start times calculate going forward';
const StartTimeReset = 'Reset start time back to its auto-calculated value';

const DeleteRowFromShow = 'Delete this row from your show';

const AddPageBreak = 'Add custom break here';
const RemovePageBreak = 'Remove custom break';

export default {
  DeleteRowFromShow,
  StartTimeEyeball,
  StartTimeReverseFlag,
  StartTimeForwardFlag,
  StartTimeReset,
  PresetDisplayTypePreset,
  PresetDisplayTypeClock,
  PresetDisplayTypeSixDigit,
  PastListTrash,
  UserDashCreateEventBtn,
  UserDashViewPastEventsBtn,
  UpcomingListEdit,
  UpcomingListDuplicate,
  UpcomingListTrash,
  ArchiveEventListRestore,
  PastListDuplicate,
  TeamMembersRemoveCrewBtn,
  EventShowsListItemEdit,
  EventShowsListItemDuplicate,
  EventShowsListItemSave,
  EventShowsListItemTrash,
  EventShowsListItemConvertShow,
  EventShowsListItemConvertList,
  EventShowsListItemConvertSchedule,
  EventShowsListItemMove,
  EventShowsListItemGuestPass,
  EventShowsListItemShowItemDesc,
  EventShowsListItemShowClocks,
  EventShowsListItemShowStartTime,
  EventShowsListItemAutoTimeCalcs,
  EventShowsListItemAutoItemNumsCalcs,
  EventShowsListItemPresetTime,
  EventShowsHeaderImportCSVBtn,
  EventUpcomingListLocation,
  EventCrewRoleSelector,
  CSSearch,
  CSHamburger,
  CSShowSelector,
  CSItemRunTime,
  CSTimeOfDay,
  CSThemeSwitcher,
  CSInfo,
  CSDownloads,
  CSHeaderCell,
  GEMHeaderCell,
  CSNoteHeaderCell,
  CSTrackingName,
  CSXLSExport,
  CSPersonalXLSExport,
  CSCSVExport,
  CSPersonalCSVExport,
  CSPersonalPDFExport,
  CSGenericPDFExport,
  CSGuestPass,
  EventGuestPass,
  CSGlobalHighlight,
  CSPersonalHighlight,
  CSProofHeaderCell,
  CSTrackItem,
  CSToolbarImage,
  CSToolbarLink,
  CSToolbarTimeStamp,
  CSSavedVsDuplicate,
  CSRestoreShow,
  CSSavedVsTitle,
  CSReturnToTrackingLink,
  CSStopBroadcastingTrackingLink,
  CSActivityFeed,
  CSActivityFeedUndoIcon,
  CSActivityFeedListIcon,
  CSDurationSuppression,
  CSRunTimeSuppression,
  EventDocsListItemRestore,
  UserDashRecentEvents,
  ResendEmailPendingUser,
  ManualCopyLink,
  EventRemoveCrewBtn,
  SignupRole1,
  SignupRole2,
  SignupRole3,
  SignupRole4,
  WordExportHeroColumnExplanation,
  WordExportShare,
  TeleprompterView,
  EnterFullscreen,
  ExitFullscreen,
  AddPageBreak,
  RemovePageBreak,
};
